import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Component, EventEmitter, Input, OnInit, Output, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-pos-payment-card',
  templateUrl: './pos-payment-card.component.html',
  styleUrls: ['./pos-payment-card.component.scss']
})
export class PosPaymentCardComponent implements OnInit, OnDestroy {
  @Input() amountOutstanding: number;
  @Input() storeId: number;
  @Input() containerId: number;
  @Input() containerDesc: string
  @Input() equipmentTypeCode: string;
  @Input() paymentType: string;

  @Output() formChanged: EventEmitter<any> = new EventEmitter<any>(null);

  formSubscription: Subscription;
  form: FormGroup;

  constructor(
    private fb: FormBuilder
  ) {
    this.form = fb.group({
      amountTendered: [null],
      amountOutstanding: [null],
      amountDifference: [null],
      // firstSixCardNumber: [null, Validators.compose([Validators.required, Validators.minLength(6), Validators.maxLength(6),Validators.pattern('[0-9]+')])],
      // lastTwoCardNumbers: [null, Validators.compose([Validators.required, Validators.minLength(2), Validators.maxLength(2),Validators.pattern('[0-9]+')])],
      lastFourCardNumbers: [null, Validators.compose([Validators.required, Validators.minLength(4), Validators.maxLength(4),Validators.pattern('[0-9]+')])],
      //lastFourCardNumbers: [null, Validators.compose([])],
    });
  }

  ngOnInit() {
    if (this.paymentType && this.paymentType === 'REFUND') {
      this.form.controls['amountTendered'].setValidators(Validators.compose([Validators.required, Validators.max(0)]));
    } else {
      this.form.controls['amountTendered'].setValidators(Validators.compose([Validators.required, Validators.min(0.01)]));
    }

    this.form.controls['amountOutstanding'].disable();
    this.form.controls['amountDifference'].disable();

    this.amountTenderedChanged();
    // this.amountTenderedFocusOut();

    this.formChanged.emit({
      containerId: this.containerId,
      equipmentTypeCode: this.equipmentTypeCode,
      formValue: this.form.value,
      formValid: this.form.valid,
    });

    this.formSubscription = this.form.valueChanges.subscribe(s => {
      this.formChanged.emit({
        containerId: this.containerId,
        equipmentTypeCode: this.equipmentTypeCode,
        formValue: this.form.value,
        formValid: this.form.valid,
      });
    });
  }

  ngOnDestroy(): void {
    if (this.formSubscription) {
      this.formSubscription.unsubscribe();
    }
  }

  amountTenderedChanged() {
    const amountTendered = +this.form.value.amountTendered || 0;
    const amountToPay = +this.amountOutstanding || 0;
    const minusOutstanding = amountTendered - amountToPay;

    this.form.controls['amountOutstanding'].setValue(+amountToPay.toFixed(2));
    this.form.controls['amountDifference'].setValue(+minusOutstanding.toFixed(2));

  }

  amountTenderedFocusOut() {
    if(!this.form.value.amountTendered) return;

    const amountTendered = +this.form.value.amountTendered || 0;
    this.form.controls['amountTendered'].setValue(+amountTendered.toFixed(2));
  }

}
